<template>
    <CodiceFeanorView tool-module="otp" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
